import React, { useRef } from 'react';
import RDatePicker, { setDefaultLocale, registerLocale } from 'react-datepicker';
import './DatePicker.scss'
import ko from 'date-fns/locale/ko'
registerLocale('ko',ko)

const DatePicker = ({ value, onChange, style, disabled, minDate, maxDate }) => {
    const dateRef = useRef(null)

    return (
        <div className='date-picker' style={ style } onClick={() => dateRef.current.setFocus()}>
            <RDatePicker
                ref={dateRef}
                dateFormatCalendar='yyyy.LL'
                maxDate={typeof maxDate === "undefined" ? new Date() : maxDate}
                minDate={minDate}
                dateFormat={'yyyy.MM.dd'}
                selected={value}
                onSelect={(date) => {dateRef.current.setFocus(false);onChange(date)}}
                locale="ko"
                shouldCloseOnSelect disabled={disabled}
            />
            <img src={require('../../aseets/icons/calendar.svg').default} className='calendar-icon' style={{ width : 24, height : 24, position : 'absolute', top : 12, right : 8 }}/>
        </div>
    )
}

export default DatePicker